const SEPARADOR_ROTULO = /\s*[-—]\s*/;

/** Remove rótulos legados corrompidos ("CNES 0000434 - CNES 0000434 …") e devolve só o nome. */
export function normalizeNomeEstabelecimento(cnes: string, nome: string): string {
  const codigo = (cnes ?? '').trim();
  let n = (nome ?? '').trim();
  if (!n) return '';
  if (!codigo) return n;

  const partes = n.split(SEPARADOR_ROTULO).map((p) => p.trim()).filter(Boolean);
  const soRepeteCnes =
    partes.length > 0 &&
    partes.every((p) => p === codigo || /^CNES\s*\d{7}$/i.test(p));
  if (soRepeteCnes) return '';

  while (/^CNES\s*\d{7}\s*[-—]\s*/i.test(n)) {
    n = n.replace(/^CNES\s*\d{7}\s*[-—]\s*/i, '').trim();
  }

  if (new RegExp(`^CNES\\s*${codigo}$`, 'i').test(n) || n === codigo) {
    return '';
  }

  return n;
}

/** Rótulo de opção de estabelecimento (combo CNES), alinhado ao formulário de usuários. */
export function formatEstabelecimentoOptionLabel(cnes: string, nome: string): string {
  const codigo = (cnes ?? '').trim();
  const nomeLimpo = normalizeNomeEstabelecimento(codigo, nome);
  if (!codigo) return nomeLimpo;
  if (!nomeLimpo) return codigo;
  return `${codigo} — ${nomeLimpo}`;
}
